import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const getTransformByDirection = (direction) => {
    const transforms = {
        top: 'translateY(-40px)',
        bottom: 'translateY(40px)',
        left: 'translateX(-40px)',
        right: 'translateX(40px)'
    };
    return transforms[direction] || transforms.top;
};

const AnimationContainer = styled.div`
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transform: ${({ isVisible, direction }) =>
        isVisible ? 'translate(0, 0)' : getTransformByDirection(direction)};
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
    transition-delay: ${({ delay }) => delay ? `${delay}s` : '0s'};
`;


  // - direction: direção da animação (default: 'top')
  //   - delay: atraso em segundos para iniciar a animação (default: 0)
  //   - threshold: porcentagem do elemento que precisa estar visível para ativar (default: 0.1 = 10%)
  //   - triggerOnce: se true, anima apenas uma vez; se false, anima toda vez que entra/sai da viewport (default: true)

export default function ScrollAnimation({
    children,
    direction = 'top',
    delay = 0,
    threshold = 0.1,
    triggerOnce = true
}) {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    if (triggerOnce) {
                        observer.disconnect();
                    }
                } else if (!triggerOnce) {
                    setIsVisible(false);
                }
            },
            {
                threshold,
                rootMargin: '0px'
            }
        );

        const currentElement = elementRef.current;
        if (currentElement) {
            observer.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, [threshold, triggerOnce]);

    return (
        <AnimationContainer
            ref={elementRef}
            isVisible={isVisible}
            direction={direction}
            delay={delay}
        >
            {children}
        </AnimationContainer>
    );
}